import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m20.267 20-6.497-6.497a5.704 5.704 0 0 1-1.79 1.026 5.983 5.983 0 0 1-2.034.363c-1.662 0-3.068-.575-4.22-1.725C4.577 12.017 4 10.61 4 8.949c0-1.661.575-3.068 1.725-4.22C6.875 3.579 8.28 3.002 9.942 3c1.661-.001 3.068.574 4.22 1.726 1.153 1.153 1.73 2.56 1.73 4.22 0 .72-.128 1.418-.383 2.093a5.682 5.682 0 0 1-1.007 1.73L21 19.265l-.733.735Zm-10.32-6.146c1.377 0 2.539-.474 3.486-1.422.948-.947 1.422-2.11 1.422-3.487 0-1.377-.474-2.54-1.422-3.486-.947-.947-2.11-1.42-3.486-1.421-1.377-.001-2.54.473-3.488 1.421-.948.948-1.422 2.11-1.421 3.486 0 1.376.474 2.538 1.421 3.486.947.949 2.11 1.422 3.487 1.422",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }